import type {ReactNode} from 'react';
import {useTranslation} from 'react-i18next';
import {useAuth} from 'hooks/auth/useAuth';
import {cn} from '@chekinapp/ui';
import {GUEST_AVATAR_CLASS} from 'pages/Auth/constants';

function StepHeading({children, lead}: {children: ReactNode; lead?: ReactNode}) {
  return (
    <div className="mb-4">
      <h1
        data-step-heading
        tabIndex={-1}
        className="text-[21px] font-bold leading-[1.25] tracking-[-0.015em] text-[color:var(--chekin-color-brand-navy)] outline-none desk:text-[28px]"
      >
        {children}
      </h1>
      {lead && (
        <p className="mt-1.5 text-[14px] leading-5 text-[color:var(--chekin-text-secondary)]">
          {lead}
        </p>
      )}
    </div>
  );
}

function SignedInAs() {
  const {t} = useTranslation();
  const {user} = useAuth();

  if (!user?.email) {
    return null;
  }

  return (
    <div className="mb-2 flex items-center gap-2 text-[13px] text-[color:var(--chekin-text-secondary)]">
      <span
        aria-hidden
        className={cn(
          GUEST_AVATAR_CLASS,
          'grid size-7 shrink-0 place-items-center text-[12px] font-bold uppercase',
        )}
      >
        {user.email.charAt(0)}
      </span>
      <span className="min-w-0 truncate">
        {t('instant_check_in.signed_in_as')}{' '}
        <b className="font-semibold text-[var(--chekin-color-brand-navy)]">
          {user.email}
        </b>
      </span>
    </div>
  );
}

export {SignedInAs, StepHeading};
